import Period, { PeriodType, Dateable } from './Period';

export { PeriodType, Dateable };
export enum PeriodsCountOption { AUTO = -1 };

const AUTO = PeriodsCountOption.AUTO;

export default class PeriodRange extends Array<Period> {
    private _type: PeriodType = PeriodType.MONTH;
    private _isLocal: boolean = false;

    constructor(other: PeriodRange);
    constructor(now: Period, periodsBefore?: number | PeriodsCountOption, periodsAfter?: number | PeriodsCountOption, isLocal?: boolean);
    constructor(type: PeriodType, now: Dateable, periodsBefore?: number | PeriodsCountOption, periodsAfter?: number | PeriodsCountOption, isLocal?: boolean);
    constructor(type: PeriodType, start: Date, end: Date, isLocal?: boolean);

    constructor(...args: any[]) {
        super();

        if (args.length === 1 && typeof args[0] === 'number') { // this one seems to be called internally from filter or map
            return new Array(args[0] as number) as PeriodRange;
        }

        if (args.length === 1 && args[0] instanceof PeriodRange) {
            this._type = args[0].type;
            this._isLocal = args[0].isLocal;
            this.push(...args[0]);
            return;
        }

        if (args[0] instanceof Period){
            args = [args[0].type, ...args];
        }

        this._type = args[0] || PeriodType.MONTH;
        let first: Period, last: Period;
        if (!(args[1] instanceof Date) || !(args[2] instanceof Date)) {
            this._isLocal = args[4] || false;

            const
                now: Period = new Period(this._type, args[1] || new Date(), this._isLocal),
                periodsBefore: number = args[2] === undefined ? AUTO : args[2],
                periodsAfter: number = args[3] === undefined ? 0 : args[3];

            switch (this._type) {
                case PeriodType.DAY:
                    first = periodsBefore === AUTO ? new Period(now).setUTCMonth(now.getUTCMonth() - 1, true).add(1) : now.add(-periodsBefore);
                    last = periodsAfter === AUTO ? new Period(now).setUTCMonth(now.getUTCMonth() + 1, true).add(-1) : now.add(periodsAfter);
                    break;

                case PeriodType.WEEK:
                    first = periodsBefore === AUTO ? new Period(now).setUTCDate(now.getUTCDate() - 7 * 20, true).add(1) : now.add(-periodsBefore);
                    last = periodsAfter === AUTO ? new Period(now).setUTCDate(now.getUTCDate() + 7 * 20, true).add(-1) : now.add(periodsAfter); break;

                case PeriodType.MONTH:
                case PeriodType.QUARTER:
                    first = periodsBefore === AUTO ? new Period(now).setUTCFullYear(now.getUTCFullYear() - 1, true).add(1) : now.add(-periodsBefore);
                    last = periodsAfter === AUTO ? new Period(now).setUTCFullYear(now.getUTCFullYear() + 1, true).add(-1) : now.add(periodsAfter);
                    break;

                case PeriodType.YEAR:
                    first = periodsBefore === AUTO ? new Period(now).setUTCFullYear(now.getUTCFullYear() - 6, true).add(1) : now.add(-periodsBefore);
                    last = periodsAfter === AUTO ? new Period(now).setUTCFullYear(now.getUTCFullYear() + 6, true).add(-1) : now.add(periodsAfter);
                    break;

                default:
                    throw new Error(`Unknown PeriodType: ${this._type}.`);
            }
        }
        else {
            this._isLocal = args[3] || false;
            first = new Period(this._type, args[1], this._isLocal);
            last = new Period(this._type, args[2], this._isLocal);
        }



        this[0] = first;
        for (var i = 0; first <= last; i++ , first = first.add(1)) {
            this[i] = first;
        }
    }

    get type(): PeriodType {
        return this._type;
    }

    get isLocal(): boolean {
        return this._isLocal;
    }

    first(): Period {
        return this[0];
    }

    start(): Date {
        return new Date(this[0]);
    }

    end(): Date {
        return new Date(this[this.length - 1].add(1).valueOf() - 1000);
    }

    last(): Period {
        return this[this.length - 1];
    }

    move(periodCount: number): PeriodRange {
        return new PeriodRange(this._type, this[0].add(periodCount), 0, this.length - 1, this._isLocal);
    }
}